import { useEffect } from 'react';
import { useRoute } from 'components/router/Routing';
import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { CreationMenu } from 'components/CreationMenu';
import { SidePanelStack } from 'components/sidePanel/SidePanelStack';
import { React } from 'libs/react';
import { CreateClientPanel } from '../panels/CreateClientPanel';
import { useTranslation } from 'components/translation/TranslationProvider';
/**
 * @component ClientQuickAddMenu
 * @since 1.0.0
 */
export function ClientQuickAddMenu(props) {
    const { style, buttonLabel, hideButton, open, redirect } = Object.assign({ style: 'normal', redirect: false }, props);
    const route = useRoute();
    const { customLabels, language } = useTranslation();
    const [title, setTitle] = useState('');
    const [picto, setPicto] = useState('');
    const [navigationStack, setNavigationStack] = useState([]);
    /**
     * @function onOpen
     * @since 1.0.0
     * @hidden
     */
    function onOpen() {
        pushPanel('create-client');
    }
    useEffect(() => {
        if (open) {
            onOpen();
        }
    }, [open]);
    /**
     * @function onBack
     * @since 1.0.0
     * @hidden
     */
    const onBack = () => {
        if (navigationStack.length == 0) {
            return;
        }
        navigationStack.pop();
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function pushPanel
     * @since 1.0.0
     * @hidden
     */
    const pushPanel = (destination) => {
        const panelIndex = PanelInfos.findIndex((info) => info.index == destination);
        const infos = PanelInfos.find((info) => info.index == destination);
        if (!infos || panelIndex < 0) {
            return;
        }
        navigationStack.push({
            index: panelIndex + 1,
            item: Object.assign(Object.assign({}, infos), { title: customLabels['Client'][language] })
        });
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        setNavigationStack([]);
    };
    /**
     * @function onClientCreateDone
     * @since 1.0.0
     * @hidden
     */
    const onClientCreateDone = (client) => {
        onClose();
        if (!redirect) {
            props.onClientCreateDone && props.onClientCreateDone(client);
        }
        else {
            route.replace({ name: 'client.update', data: { id: client.id } });
        }
    };
    useEffect(() => {
        var _a, _b;
        const lastItem = navigationStack.length > 0
            ? navigationStack[navigationStack.length - 1]
            : null;
        setTitle((_a = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.title) !== null && _a !== void 0 ? _a : '');
        setPicto((_b = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.picto) !== null && _b !== void 0 ? _b : '');
    }, [navigationStack]);
    const className = classNames('quick-add-panel-stack', 'quick-add-panel-stack--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(CreationMenu, { active: navigationStack.length > 0, onOpen: onOpen, hideButton: hideButton, buttonWithLabel: true, label: buttonLabel },
            React.createElement(SidePanelStack, { active: navigationStack.length > 0, activeIndex: navigationStack.length > 0
                    ? navigationStack[navigationStack.length - 1].index
                    : 0, onBack: onBack, title: title, picto: picto, onClose: onClose },
                React.createElement(CreateClientPanel, { onDone: onClientCreateDone })))));
}
/**
 * @const PanelInfos
 * @since 1.0.0
 */
export const PanelInfos = [
    {
        index: 'create-client',
        title: t('Client')
    }
];
